<template>
  <div class="Handover">
    <div class="twolabs">
      <el-tabs  tab-position="left" type="card" style="height: 200px;">
        <el-tab-pane  label="Shift Switch" v-if="isShow">
          <div class="first-lab-right">
            <p>
              <span class="front-fontstyle" style="display:inline-block;">Shift time： </span>{{userInfo.startWorkDate}} ~ {{userInfo.endWorkDate}}</p>
            <p>
              <span class="front-fontstyle" style="display:inline-block;">Operator： </span>{{userInfo.agentName}}</p>
            <p>
              <span class="front-fontstyle" style="display:inline-block;">Operator ID ： </span>{{userInfo.agentCode}}</p>
          </div>
          <ul class="totalInfo">
            <li>
              <p>The Number of Applicant</p>
              <p>{{userInfo.totalInsured}}</p>
            </li>
            <li>
              <p>Total Cash Income(USD)</p>
              <p>{{userInfo.totalPremium}}</p>
            </li>
            <li>
              <p>Qty refund people</p>
              <p>{{userInfo.revokeSum}}</p>
            </li>
            <li>
              <p>Sum insured of refund</p>
              <p>{{userInfo.revokeAmt}}</p>
            </li>
          </ul>
          <el-button type="primary" class="changebtn" @click="changeOrder">Shift Switch</el-button>
        </el-tab-pane>
        <el-tab-pane label="Record">
          <div class="second-lab-right">
            <el-row>
              <el-col>
                <el-form :inline="true" :model="formInline" class="demo-form-inline wordorder-form">
                  <el-form-item style="marginRight: 0;" label="Form ：" label-width="110px">
                    <el-col>
                      <el-date-picker type="datetime" @change="getStartTime($event)" placeholder="Select start time" v-model="formInline.startTime" style="width: 100%;"></el-date-picker>
                    </el-col>
                  </el-form-item>
                  <el-form-item style="marginRight: 0;" label="To ：" label-width="110px">
                    <el-col>
                      <el-date-picker type="datetime" @change="getEndTime($event)" placeholder="Select expiry time" v-model="formInline.endTime" style="width: 100%;"></el-date-picker>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="Insurance Branch：" label-width="150px">
                    <el-cascader :options="saleBarnchs" placeholder="Select insurance branch" clearable v-model="formInline.organization" @change="onSaleBarnchChange">
                    </el-cascader>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" style="position: absolute;" @click="getDataList(1)">Search</el-button>
                  </el-form-item>
                  <el-col class="lastform">
                    <el-form-item label="Operator：" label-width="110px">
                      <el-select v-model="formInline.userId" placeholder="Select operator" clearable @change="getDataList(1)">
                        <el-option v-for="item in personOptions" :key="item.userId" :label="item.agentName" :value="item.userId">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-form>
              </el-col>
            </el-row>
          </div>
          <div class="totalrecord">Result of
            <span class="lineheightfont">{{totalLine}} </span>
          </div>
          <div style="height:618px; overflow:auto;" @scroll="onScroll($event)" ref="tableWrap">
            <el-table :data="tableData" style="width: 100%" v-loading="loading" class="handover-table">
              <el-table-column prop="endWorkDate" label="Shift Switch Time">
              </el-table-column>
              <el-table-column prop="agentName" label="Operator">
              </el-table-column>
              <el-table-column prop="agentCode" label="Operator ID">
              </el-table-column>
              <el-table-column prop="branchName" label="Insurance Branch">
              </el-table-column>
              <el-table-column prop="totalInsured" label="Total Insured">
              </el-table-column>
              <el-table-column prop="totalPremium" label="Payment from Customer" min-width="90">
              </el-table-column>
              <el-table-column prop="revokeSum" label="qty refund people">
              </el-table-column>
              <el-table-column prop="revokeAmt" label="sum insured of refund">
              </el-table-column>
            </el-table>
          </div>

        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog title="Shift Switch Confirm" :visible.sync="dialogChange" custom-class="problem-content" append-to-body>
      <div class="content" style="margin-top: -10px">
        <p style="font-size: 16px; color: #666;margin-bottom:15px;">Are you sure about shift Switch?</p>
        <div class="btnwrap">
          <el-button  @click="dialogChange=false" style="margin-top: 10px;">Cancel</el-button>
          <el-button type="primary" @click="handleconfirm" style="margin-top: 10px;">Confirm</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 异常弹窗end -->
  </div>
</template>
<script>
import INTERFACE from '../../interface'
import fecha from 'fecha'
// import locale from 'element-ui/lib/locale/lang/en'
//  import globalConfig from '../../config'  Shift Switch

export default {
  components: {
  },
  data() {
    return {
      totalLine: 0,
      loading: false,
      I18n: window.I18n,
      dialogChange: false,
      isBottom: false,
      isShow: true,
      formInline: {
        beginDate: '',
        endDate: '',
        branchId: [],
        userId: ''
      },
      queryObj: {
        beginDate: '',
        endDate: '',
        branchId: [],
        userId: '',
        currentPage: 1,
        pageSize: 30
      },
      userInfo: {
        startWorkDate: '',
        endWorkDate: '',
        agentName: '',
        totalInsured: '',
        totalPremium: ''
      },
      saleBarnchs: [],
      personOptions: [],
      tableData: []
    }
  },
  beforeCreate() {
    // 获取用户信息
    INTERFACE.getuserInfo().then(data => {
      if (data.data.userType === 'EMPLOYEE') {
        this.isShow = false
      } else {
        this.isShow = true
      }
    })
  },
  created() {
    INTERFACE.getchangeList({ pageSize: 30, currentPage: 1 }).then(data => {
      this.loading = false
      this.totalLine = data.data.totalLine
      if (data.data.data && data.data.data.length > 0) {
        data.data.data.forEach(item => {
          item.endWorkDate = this.getTime(item.endWorkDate)
        })
        this.tableData = data.data.data
      } else {
        this.tableData = []
      }
    })
    // 获取代理人列表
    INTERFACE.getagentNameList().then(data => {
      if (data.data && data.data.length > 0) {
        this.personOptions = data.data
      } else {
        this.personOptions = []
      }
    })
    // 获取机构列表
    INTERFACE.getbranchList().then(data => {
      this.saleBarnchs = data.data[0].childs;
      const getOptions = function(data, valueAlias, labelAlias) {
        let res = [];
        data.forEach((t, index) => {
          res[index] = {
            value: t[valueAlias],
            label: t[labelAlias]
          }
          if (t.childs && t.childs.length) {
            res[index].children = getOptions(t.childs, valueAlias, labelAlias);
          }
        })
        return res;
      };
      this.saleBarnchs = getOptions(data.data, 'branchId', 'branchName');
    });

    INTERFACE.getchangeuserInfo().then(data => {
      if (data.data) {
        data.data.startWorkDate = this.getTime(data.data.startWorkDate)
        data.data.endWorkDate = this.getTime(data.data.endWorkDate)
        this.userInfo = data.data
      }
    })
  },
  methods: {
    handleconfirm() {
      window.external.LoginOut()
      this.dialogChange = false
    },
    changeOrder() {
      this.dialogChange = true
    },
    getTime(value) {
      if (value && value !== 0) {
        const date = new Date(+value);
        return fecha.format(date, 'YYYY-MM-DD HH:mm')
      }
    },
    getDataList(val) {
      this.queryObj.currentPage = val
      this.queryObj.userId = this.formInline.userId
      this.isBottom = false
      INTERFACE.getchangeList(this.queryObj).then(data => {
        this.totalLine = data.data.totalLine
        if (data.data.data && data.data.data.length > 0) {
          data.data.data.forEach(item => {
            item.endWorkDate = this.getTime(item.endWorkDate)
          })
          this.tableData = data.data.data
        } else {
          this.tableData = []
        }
      })
    },
    getTableConcatList() {
      this.queryObj.userId = this.formInline.userId
      if (this.isBottom) return
      INTERFACE.getchangeList(this.queryObj).then(data => {
        // this.totalLine = data.data.totalLine
        this.loading = false
        if (data.data.data && data.data.data.length > 0) {
          data.data.data.forEach(item => {
            item.endWorkDate = this.getTime(item.endWorkDate)
          })
          // this.tableData = data.data.data.reverse().concat(this.tableData);
          this.tableData = this.tableData.concat(data.data.data);
        } else {
          this.isBottom = true
        }
      })
    },
    getStartTime(value) {
      if (value) {
        this.queryObj.beginDate = Date.parse(new Date(value))
      } else {
        this.queryObj.beginDate = ''
      }
    },
    getEndTime(value) {
      if (value) {
        this.queryObj.endDate = Date.parse(new Date(value))
      } else {
        this.queryObj.endDate = ''
      }
    },
    handleChange() {

    },
    onSaleBarnchChange(arr) {
      let curObj = this.saleBarnchs;
      arr.forEach((t, index) => {
        curObj = curObj.find(it => it.value === t);
        if (curObj.children) curObj = curObj.children;
        // if (index === arr.length - 1 && curObj) resObj = curObj;
      })
      this.queryObj.branchId = curObj.value
      this.getDataList()
    },
    onScroll(event) {
      if (event.target.scrollTop + event.target.clientHeight === event.target.scrollHeight) {
        if (this.isBottom) return
        this.loading = true
        this.queryObj.currentPage += 1
        this.getTableConcatList()
      }
    }
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
  @import "index.styl"
</style>



// WEBPACK FOOTER //
// src/pages/HandOver/index.vue